// extracted by mini-css-extract-plugin
export default {"DogItem":"DogItem_DogItem__QhUGJ","link":"DogItem_link__vUTIU","name":"DogItem_name__im7e6","portrait":"DogItem_portrait__GnpLF","fallback":"DogItem_fallback__NoZT7"};